import type { AuthChangeEvent } from "@supabase/supabase-js";

export type AuthMembershipAction = "hydrate" | "refresh_profile" | "clear" | "none";

/**
 * Supabase may emit SIGNED_IN more than once for an already-established
 * browser session. Re-hydrating organization membership for the same user
 * flips the whole app into its loading shell and unmounts in-progress forms.
 *
 * Only a real user identity change requires a full membership hydration.
 */
export function authMembershipAction(
  event: AuthChangeEvent,
  previousUserId: string | null,
  nextUserId: string | null,
): AuthMembershipAction {
  if (!nextUserId) return "clear";
  if (event === "TOKEN_REFRESHED") return "none";
  if (previousUserId === nextUserId) {
    return event === "USER_UPDATED" ? "refresh_profile" : "none";
  }
  return "hydrate";
}
